import { render, staticRenderFns } from "./ErrorWrapper.vue?vue&type=template&id=2547978f&scoped=true&"
import script from "./ErrorWrapper.vue?vue&type=script&lang=js&"
export * from "./ErrorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ErrorWrapper.vue?vue&type=style&index=0&id=2547978f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547978f",
  null
  
)

export default component.exports